import { render, staticRenderFns } from "./Comprobacion.vue?vue&type=template&id=242787d2&"
import script from "./Comprobacion.vue?vue&type=script&lang=js&"
export * from "./Comprobacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports